import { map } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

/**
 * tokens
 */
import { AUTH_IS_LOGGED_IN } from '@identity/authentication';

export const isLoggedInGuard: CanActivateFn = (route, state) => {
  
  // injects
  const _router = inject(Router);
  const _auth = inject(AUTH_IS_LOGGED_IN);

  // check if user isLoggedIn
  return _auth.isLoggedIn$.pipe<true | RedirectCommand>(
    map(isLoggedIn => {

      if (isLoggedIn) return true;

      return new RedirectCommand(_router.parseUrl('/auth'))

    })
  )

};
